import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { truncate } from 'lodash-es';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'page-settings-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbsComponent {
  @Input()
  set breadcrumbs(v: any[]) {
    this._breadcrumbs = v.map((item, index) => {
      if (index === v.length - 1)
        return {
          ...item,
          styleClass: item.label && item.label.length > 20 ? 'menuitem-break' : '',
          routerLink: null,
          label: truncate(item.label ?? '', { length: 40 }),
        };
      return {
        ...item,
        styleClass: item.label && item.label.length > 20 ? 'menuitem-break' : '',
        label: truncate(item.label ?? '', { length: 40 }),
      };
    });
  }
  get breadcrumbs() {
    return this._breadcrumbs;
  }

  @Input()
  styleClass = '';

  @HostBinding('class')
  get getClass() {
    return this.styleClass;
  }

  private _breadcrumbs: MenuItem[] = [];
}
